<div class="card card-custom gutter-b example example-compact top-align">
  <div class="card-header">
      <h3 class="card-title">Candidate Feedback Form (Assessment Stage)</h3>
      <div class="card-toolbar">
        <div *ngIf="feedbackType !== 'non'" class="example-tools justify-content-center">
          <button class="btn btn-secondary float-right"  (click)='goBack()'>Back</button>
      </div>
      </div>
  </div>
  <div class="card-body" *ngIf="showLabel">
    <h2 >No Feedback Available</h2>
  </div>
  <div class="card-body" >
      <form class="form" [formGroup]="candidateAttendaceForm">
        <ng-container *ngIf="!hideForm">
          <div  formArrayName="feedbacks"
          *ngFor="let question of candidateAttendaceForm.get('feedbacks')['controls']; let i = index" class="form-group">
          <ng-container [formGroupName]="i">
            
            <div *ngIf="questions[i].id !== 'Q3'">
              <div *ngIf="questions[i].id !== 'Q6'" formGroupName="feedback">
                <label class="label-text" >{{questions[i].id}}) {{displayQuestion(questions[i].id,questions[i].questionString)}}</label>
                
                <ng-container *ngIf="questions[i].id !== 'Q2'">
                  <div *ngIf="questions[i].id !== 'Q7'" class="radio-list" >
                    <label style="margin-left: 20px;" class="radio">
                        <input type="radio" (change)="isBelowRequired(i)"  formControlName="choice"  [value]="true" >
                        <span></span>
                        Yes
                    </label>
                    <label style="margin-left: 20px;"  class="radio">
                      <input type="radio" (change)="isBelowRequired(i)"  formControlName="choice"  [value]="false" >
                      <span></span>
                      No
                  </label>
                </div>
                </ng-container>
                <ng-container *ngIf="questions[i].id === 'Q2'">
                  <div class="radio-list" >
                    <label style="margin-left: 20px;" class="radio">
                        <input type="radio"   formControlName="choice"  value="Online" >
                        <span></span>
                        Online
                    </label>
                    <label style="margin-left: 20px;"  class="radio">
                      <input type="radio"   formControlName="choice"  value="Classroom" >
                      <span></span>
                      Classroom
                  </label>
                  <label style="margin-left: 20px;"  class="radio">
                    <input type="radio"   formControlName="choice"  value="Blended" >
                    <span></span>
                    Blended
                </label>
                <label style="margin-left: 20px;"  class="radio">
                  <input type="radio"   formControlName="choice"  value="OJT" >
                  <span></span>
                  OJT ( on the job training )
              </label>
                </div>
                </ng-container>
             

                  <div *ngIf="questions[i].id === 'Q7'" [formGroup]="candidateAttendaceForm">
                    <div class="checkbox-list" >
                        <label class="checkbox"> 
                            <input type="checkbox" (change)="checkIfOthers()" formControlName="trainer">
                            <span></span>
                            Trainer
                        </label><br>
                        <label class="checkbox"> 
                          <input type="checkbox" (change)="checkIfOthers()" formControlName="equipmentForTraining">
                          <span></span>
                          Equipment for training
                      </label><br>
                      <label class="checkbox"> 
                        <input type="checkbox" (change)="checkIfOthers()" formControlName="qualityOfTrainingDelivery">
                        <span></span>
                        Quality of training delivery
                    </label><br>
                    <label class="checkbox"> 
                      <input type="checkbox" (change)="checkIfOthers()" formControlName="qualityOfCourseMaterials">
                      <span></span>
                      Quality of course materials
                  </label><br>
                  <label class="checkbox"> 
                    <input type="checkbox" (change)="checkIfOthers()" formControlName="qualityOfAssessment">
                    <span></span>
                    Quality of assessment
                </label> <br>
                <label class="checkbox"> 
                  <input type="checkbox" (change)="checkIfOthers()" formControlName="supportFromTPonPlacement">
                  <span></span>
                  Support from TP on placement
              </label><br>
              <label class="checkbox"> 
                <input type="checkbox" (change)="checkIfOthers()" formControlName="others">
                <span></span>
                Others
            </label><br>
            <div class="form-group" *ngIf="candidateAttendaceForm.get('others').value === true  ">
              <input style="width: 32%;" formControlName="otherAnswer"  type="text" maxlength="50"  class="form-control" placeholder="Write your asnwer ( max character: 50 )">
            </div>
                </div>
                </div>
            </div>
            </div>
           
            <ng-container [formGroup]="qualityRatingForm">
              <div *ngIf="questions[i].id === 'Q3'" >
                <label class="label-text" >{{questions[i].id}}){{questions[i].questionString}}</label>
                
                <table class="notranslate table table-striped m-table">
                  <thead >
                      <tr>
                        <th>
                          
                        </th>
                        <th>
                          Poor
                        </th>
                         <th>
                          Average
                        </th>
                        <th>
                          Good
                        </th>
                        <th>
                          Very good
                        </th>
                        <th>
                          Excellent
                        </th>
                        <th>
                          N/A
                        </th>
                      </tr>
                     
                     
                  </thead>
                  <tbody class="notranslate">
                      <ng-container class="notranslate">
                          <tr formArrayName="rating"
                          *ngFor="let question of qualityRatingForm.get('rating')['controls']; let idx = index" class="form-group">
                          <ng-container [formGroupName]="idx">
                            <ng-container  formGroupName="ratingArray">
                              <td >
                                {{qualityRatingForm.get('rating')['controls'][idx].get('ratingArray').value.question}}
                              </td>
                              <td >
                                <input type="radio"   formControlName="choice" value="Poor">
                              </td>
                              <td >
                                <input type="radio"  formControlName="choice" value="Average">
                              </td>
                              <td >
                                <input type="radio"  formControlName="choice" value="Good">
                              </td>
                              <td >
                                <input type="radio"  formControlName="choice" value="Very Good">
                              </td>
                              <td >
                                <input type="radio"  formControlName="choice" value="Excellent">
                              </td>
                              <td >
                                <ng-container *ngIf="qualityRatingForm.get('rating')['controls'][idx].get('ratingArray').value.question === 'Support from TP on placement'">
                                  <input type="radio"  formControlName="choice" value="N/A">
                                </ng-container>
                              </td>
                            </ng-container>
                            
                          </ng-container>
                          </tr>
                      </ng-container>
                  </tbody>
              </table>
            </div>
            </ng-container>


            <ng-container *ngIf="questions[i].id === 'Q6'" formGroupName="feedback">
              <label class="label-text" >{{questions[i].id}}) {{questions[i].questionString}}</label>
              <div class="radio-list" >
                  <label style="margin-left: 20px;" class="radio">
                      <input type="radio"  formControlName="choice" (change)="validate(i)"  value="1" >
                      <span></span>
                      1
                  </label>
                  <label style="margin-left: 20px;"  class="radio">
                    <input type="radio"  formControlName="choice" (change)="validate(i)" value="2" >
                    <span></span>
                    2
                </label>
                <label style="margin-left: 20px;"  class="radio">
                  <input type="radio"  formControlName="choice" (change)="validate(i)"  value="3" >
                  <span></span>
                  3
              </label>
              <label style="margin-left: 20px;"  class="radio">
                <input type="radio"  formControlName="choice" (change)="validate(i)"  value="4" >
                <span></span>
                4
            </label>
            <label style="margin-left: 20px;"  class="radio">
              <input type="radio"  formControlName="choice" (change)="validate(i)"  value="5" >
              <span></span>
              5
          </label>
              </div>
            </ng-container>
            <!-- Q3 Questions -->
          </ng-container>
          </div>
        </ng-container>
        
          <div class="card-footer">
            <ng-container *ngIf="role !== 'Training Partner'">
              <ng-container *ngIf="feedbackType === 'non'">
              <ng-container *ngIf="!isUpdate">
                <button [disabled]="candidateAttendaceForm.status === 'INVALID'" *ngIf="role !== 'Training Partner'"  class="btn btn-primary mr-2"  (click)="sumitFeedback()">Submit</button>
                <!-- <button *ngIf="role !== 'Training Partner'"  class="btn btn-primary mr-2"  (click)="reset()">Reset</button> -->

              </ng-container>
             
              </ng-container>
            </ng-container>
     
            
            <!-- <button  class="btn btn-secondary" (click)="goBack()">Back</button> -->
          </div>
      </form>
</div>
</div>

   